import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeIcon, QrCodeIcon, SendIcon, HistoryIcon, RefreshCwIcon, UserIcon, LogOutIcon, ChevronDownIcon, ChevronRightIcon, MenuIcon, XIcon, BarChart3Icon, ListIcon, MessageSquareIcon, ShieldAlertIcon } from 'lucide-react';
interface MobileSidebarProps {
  onLogout: () => void;
}
const MobileSidebar: React.FC<MobileSidebarProps> = ({
  onLogout
}) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [qrcExpanded, setQrcExpanded] = useState(false);
  const isActive = (path: string) => {
    return location.pathname === path;
  };
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  return <div className="md:hidden" data-id="element-438">
      <button onClick={toggleSidebar} className="fixed top-4 right-4 z-[60] p-2 rounded-lg bg-white text-slate-700 shadow-md border border-slate-200 hover:bg-slate-50 transition-colors" data-id="element-439">
        {isOpen ? <XIcon className="h-5 w-5" data-id="element-440" /> : <MenuIcon className="h-5 w-5" data-id="element-441" />}
      </button>

      {isOpen && <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-40 transition-opacity" onClick={toggleSidebar} data-id="element-442"></div>}

      <div className={`fixed top-0 left-0 h-full w-72 bg-slate-100 z-50 transform transition-transform duration-300 ease-in-out shadow-2xl flex flex-col ${isOpen ? 'translate-x-0' : '-translate-x-full'}`} data-id="element-443">
        {/* Logo & Merchant Info */}
        <div className="p-6 border-b border-slate-200" data-id="element-444">
          <div className="flex items-center space-x-3 mb-6" data-id="element-445">
            <img src="https://cdn.magicpatterns.com/uploads/vRyb2gjrsLofr6hM6xeb2a/Paysys_Logo.png" alt="Paysys" className="h-8 w-auto object-contain" data-id="element-446" />
          </div>

          <div className="bg-white rounded-xl p-4 border border-slate-200 shadow-sm" data-id="element-447">
            <div className="text-sm font-semibold text-slate-800 mb-1" data-id="element-448">
              Gadgets Zone
            </div>
            <div className="flex justify-between items-center text-xs text-slate-500 mb-1" data-id="element-449">
              <span data-id="element-450">MID:</span>
              <span className="font-mono" data-id="element-451">050102100023650</span>
            </div>
            <div className="flex justify-between items-center text-xs text-slate-500" data-id="element-452">
              <span data-id="element-453">TID:</span>
              <span className="font-mono" data-id="element-454">2365010001</span>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 overflow-y-auto custom-scrollbar" data-id="element-455">
          <div className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3 px-3" data-id="element-456">
            Main Menu
          </div>
          <ul className="space-y-1.5" data-id="element-457">
            <li data-id="element-458">
              <Link to="/dashboard" onClick={toggleSidebar} className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/dashboard') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-459">
                <HomeIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-460" />
                <span className="font-medium text-sm" data-id="element-461">Dashboard</span>
              </Link>
            </li>

            <li data-id="element-462">
              <button onClick={() => setQrcExpanded(!qrcExpanded)} className={`flex items-center justify-between w-full px-3 py-2.5 rounded-lg transition-all duration-200 ${location.pathname.includes('/qrc') ? 'bg-indigo-100 text-indigo-700' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-463">
                <div className="flex items-center" data-id="element-464">
                  <QrCodeIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-465" />
                  <span className="font-medium text-sm" data-id="element-466">QRC Management</span>
                </div>
                {qrcExpanded ? <ChevronDownIcon className="h-4 w-4" data-id="element-467" /> : <ChevronRightIcon className="h-4 w-4" data-id="element-468" />}
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${qrcExpanded ? 'max-h-40 opacity-100 mt-1' : 'max-h-0 opacity-0'}`} data-id="element-469">
                <ul className="pl-11 space-y-1 relative before:absolute before:left-5 before:top-0 before:bottom-2 before:w-px before:bg-slate-300" data-id="element-470">
                  <li data-id="element-471">
                    <Link to="/qrc/static" onClick={toggleSidebar} className={`block py-2 text-sm transition-colors relative before:absolute before:left-[-24px] before:top-1/2 before:w-4 before:h-px before:bg-slate-300 ${isActive('/qrc/static') ? 'text-indigo-600 font-medium' : 'text-slate-500 hover:text-slate-900'}`} data-id="element-472">
                      Static QRC
                    </Link>
                  </li>
                  <li data-id="element-473">
                    <Link to="/qrc/static-amount" onClick={toggleSidebar} className={`block py-2 text-sm transition-colors relative before:absolute before:left-[-24px] before:top-1/2 before:w-4 before:h-px before:bg-slate-300 ${isActive('/qrc/static-amount') ? 'text-indigo-600 font-medium' : 'text-slate-500 hover:text-slate-900'}`} data-id="element-474">
                      Static QRC with Amount
                    </Link>
                  </li>
                  <li data-id="element-475">
                    <Link to="/qrc/dynamic" onClick={toggleSidebar} className={`block py-2 text-sm transition-colors relative before:absolute before:left-[-24px] before:top-1/2 before:w-4 before:h-px before:bg-slate-300 ${isActive('/qrc/dynamic') ? 'text-indigo-600 font-medium' : 'text-slate-500 hover:text-slate-900'}`} data-id="element-476">
                      Dynamic Payment QRC
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            <li data-id="element-477">
              <Link to="/request-to-pay" onClick={toggleSidebar} className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/request-to-pay') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-478">
                <SendIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-479" />
                <span className="font-medium text-sm" data-id="element-480">Request to Pay</span>
              </Link>
            </li>

            <li data-id="element-481">
              <Link to="/rtp-lists" onClick={toggleSidebar} className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/rtp-lists') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-482">
                <ListIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-483" />
                <span className="font-medium text-sm" data-id="element-484">RTP Lists</span>
              </Link>
            </li>

            <li data-id="element-485">
              <Link to="/transaction-history" onClick={toggleSidebar} className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/transaction-history') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-486">
                <HistoryIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-487" />
                <span className="font-medium text-sm" data-id="element-488">Transaction History</span>
              </Link>
            </li>

            <li data-id="element-489">
              <Link to="/disputes" onClick={toggleSidebar} className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/disputes') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-490">
                <ShieldAlertIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-491" />
                <span className="font-medium text-sm" data-id="element-492">Disputes</span>
              </Link>
            </li>

            <li data-id="element-493">
              <Link to="/support-tickets" onClick={toggleSidebar} className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/support-tickets') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-494">
                <MessageSquareIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-495" />
                <span className="font-medium text-sm" data-id="element-496">Support & Requests</span>
              </Link>
            </li>

            <div className="pt-4 pb-2" data-id="element-497">
              <div className="h-px bg-slate-200 w-full" data-id="element-498"></div>
            </div>

            <div className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3 px-3" data-id="element-499">
              Settings
            </div>

            <li data-id="element-500">
              <Link to="/merchant-assessment" onClick={toggleSidebar} className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/merchant-assessment') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-501">
                <BarChart3Icon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-502" />
                <span className="font-medium text-sm" data-id="element-503">Merchant Assessment</span>
              </Link>
            </li>

            <li data-id="element-504">
              <Link to="/update-profile" onClick={toggleSidebar} className={`flex items-center px-3 py-2.5 rounded-lg transition-all duration-200 ${isActive('/update-profile') ? 'bg-indigo-500 text-white shadow-md shadow-indigo-500/20 relative before:absolute before:left-0 before:top-2 before:bottom-2 before:w-1 before:bg-white before:rounded-r-full' : 'text-slate-600 hover:text-slate-900 hover:bg-white'}`} data-id="element-505">
                <UserIcon className="h-5 w-5 mr-3 flex-shrink-0" data-id="element-506" />
                <span className="font-medium text-sm" data-id="element-507">Profile Settings</span>
              </Link>
            </li>
          </ul>
        </nav>

        {/* Logout */}
        <div className="p-4 border-t border-slate-200" data-id="element-508">
          <button onClick={() => {
          toggleSidebar();
          onLogout();
        }} className="flex items-center px-3 py-2.5 rounded-lg text-slate-600 hover:bg-red-50 hover:text-red-600 w-full transition-colors group" data-id="element-509">
            <LogOutIcon className="h-5 w-5 mr-3 flex-shrink-0 group-hover:text-red-600" data-id="element-510" />
            <span className="font-medium text-sm" data-id="element-511">Logout</span>
          </button>
        </div>
      </div>
    </div>;
};
export default MobileSidebar;